import React, { useState, useEffect } from 'react';
import CopyrightFooter from 'components/common/CopyrightFooter';
import useStyles from './Styles';
import { AppRouteURI } from 'router/RoleBasedAccess';
import AuthActions from '../actions';
import { AlertTitle, Alert } from '@mui/material';
import { USER_LOGIN_URL } from 'api/AuthConstants';
import { useHistory } from 'react-router';
import { useFormik } from 'formik';
import * as yup from 'yup';
import AppActions from 'components/app/actions';
import Styles from './Styles';
import UnstyledLink from 'components/common/UnstyledLink';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import { Avatar, Box, Typography, Link, Grid, CssBaseline, TextField, Button, Container, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const validationSchema = yup.object({
    email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email is required'),
    password: yup
        .string('Enter your password')
        // .min(8, 'Password should be of minimum 8 characters length')
        .required('Password is required'),
});

export default function () {
    const classes = useStyles();
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [invalidCredentials, setInvalidCredentials] = useState(false);
    const [alert, setAlert] = useState({ title: '', message: '', serverity: '' });
    const [suspended, setSuspended] = useState(false);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const { setToastMessage } = AppActions();

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            loginUser(values.email.toLowerCase(), values.password);
        }
    });

    const loginUser = (email, password) => {
        setLoading(true);
        fetch(USER_LOGIN_URL,
            {
                method: 'POST',
                body: JSON.stringify({ email, password }),
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        )
            .then((response) => response.json())
            .then((data) => {
                if (data.authenticated) {
                    history.push(AppRouteURI.HOME);
                }
                else {
                    setAlert({
                        title: data.status.toLowerCase().replace('_', ' '),
                        message: data.status_message,
                        severity: 'error'
                    });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            })
            .finally(() => {
                setLoading(false);
            });

    };

    return (
        <Container component="main" maxWidth="xs">
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon style={{ color: 'black' }} />
                </Avatar>
                <Typography component="h1" variant="h5" color="textPrimary">
                    Sign in
                </Typography>
                {alert.title && <Alert severity={alert.severity} style={{ marginTop: '1rem' }}>
                    <AlertTitle style={{ textTransform:"capitalize" }}>{alert.title}</AlertTitle>
                    {alert.message}
                </Alert>}
                <form method='POST' className={classes.form} onSubmit={formik.handleSubmit}>
                    <TextField
                        variant='outlined'
                        fullWidth
                        id="email"
                        name="email"
                        label="Email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                        autoComplete="email"
                    />
                    <TextField
                        variant='outlined'
                        fullWidth
                        id="password"
                        name="password"
                        label="Password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.password && Boolean(formik.errors.password)}
                        helperText={formik.touched.password && formik.errors.password}
                        autoComplete="current-password"
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => setShowPassword((prev) => !prev)}
                                        edge="end"
                                        aria-label="toggle password visibility"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    {/* <FormControlLabel
                    control={<Checkbox value="remember" color="primary" onChange={(e) => setRememberMe(e.target.checked)} checked={rememberMe} />}
                    label="Remember me"
                /> */}
                    <Button disableElevation
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Sign In
                    </Button>
                </form>
                <Grid container style={{ marginTop: '1rem' }}>
                    <Grid item xs>
                        <Link variant="body2">
                            <UnstyledLink to={AppRouteURI.RESET_PWD}>
                                Forgot password?
                            </UnstyledLink>
                        </Link>
                    </Grid>
                    {/* <Grid item>
                        <Link variant="body2">
                            <UnstyledLink to={AppRouteURI.REGISTER}>
                                {"Don't have an account? Sign Up"}
                            </UnstyledLink>
                        </Link>
                    </Grid> */}
                </Grid>
            </div>
            <Box mt={8}>
                <CopyrightFooter />
            </Box>
        </Container>
    );
}